import Icon from './Icon';

const StaffFansStatsCard = ({ title, value, iconName }) => {
  return (
    <div style={{
      display: 'flex',
      height: '116px',
      padding: '16px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '32px',
      flex: '1 0 0',
      borderRadius: '12px',
      background: 'var(--Gray-1, #F8F8F8)',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }}>
        <span style={{
          overflow: 'hidden',
          color: 'var(--Black, #000)',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontFamily: '"Baikal Book"',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '340',
          lineHeight: '110%'
        }}>
          {title}
        </span>
        <Icon name={iconName} size={14} />
      </div>
      <div style={{
        position: 'absolute',
        bottom: '16px',
        left: '16px',
        right: '16px',
        color: 'var(--Black, #000)',
        textAlign: 'left',
        fontFamily: '"Baikal ExtraCondensedBold"',
        fontSize: '36px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
        {value}
      </div>
    </div>
  );
};

export default StaffFansStatsCard;